import { put } from 'redux-saga/effects';
import { push } from 'connected-react-router';

import { resetContactForm } from '../actions/index';

export function* navigateTo({ url }) {
  yield put(push(url));
  yield put(resetContactForm());
};
